import React from "react";

const ActivitiesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7252_13114)">
        <path
          d="M10.0017 13.1283C10.9906 13.1283 11.7924 12.3266 11.7924 11.3376C11.7924 10.3486 10.9906 9.54688 10.0017 9.54688C9.01267 9.54688 8.21094 10.3486 8.21094 11.3376C8.21094 12.3266 9.01267 13.1283 10.0017 13.1283Z"
          fill="#454242"
        />
        <path
          d="M8.50137 5.08271C8.50137 3.19767 6.96776 1.66406 5.08271 1.66406C3.19767 1.66406 1.66406 3.19767 1.66406 5.08271C1.66406 6.96776 3.19767 8.50137 5.08271 8.50137C6.96776 8.50137 8.50137 6.96776 8.50137 5.08271ZM3.61758 5.08271C3.61758 4.813 3.83624 4.59434 4.10596 4.59434H4.59434V4.10596C4.59434 3.83624 4.813 3.61758 5.08271 3.61758C5.35243 3.61758 5.57109 3.83624 5.57109 4.10596V5.08271C5.57109 5.35243 5.35243 5.57109 5.08271 5.57109H4.10596C3.83624 5.57109 3.61758 5.35243 3.61758 5.08271Z"
          fill="#454242"
        />
        <path
          d="M14.9147 1.66406C13.0297 1.66406 11.4961 3.19767 11.4961 5.08271C11.4961 6.96776 13.0297 8.50137 14.9147 8.50137C16.7998 8.50137 18.3334 6.96776 18.3334 5.08271C18.3334 3.19767 16.7998 1.66406 14.9147 1.66406ZM15.4031 5.08271C15.4031 5.16844 15.3806 5.25267 15.3377 5.3269L14.8493 6.17281C14.7144 6.40638 14.4158 6.48641 14.1822 6.35156C13.9486 6.2167 13.8686 5.91801 14.0034 5.68443L14.4264 4.95186V4.10596C14.4264 3.83624 14.645 3.61758 14.9147 3.61758C15.1845 3.61758 15.4031 3.83624 15.4031 4.10596V5.08271Z"
          fill="#454242"
        />
        <path
          d="M4.83147 10.3173C4.45002 9.93589 3.83157 9.93589 3.45014 10.3173C3.06872 10.6988 3.06869 11.3173 3.45014 11.6987L3.79549 12.044L5.17682 10.6627L4.83147 10.3173Z"
          fill="#454242"
        />
        <path
          d="M15.1696 10.3173L14.8242 10.6627L16.2055 12.044L16.5509 11.6987C16.9324 11.3172 16.9324 10.6988 16.5509 10.3173C16.1694 9.93591 15.551 9.93587 15.1696 10.3173Z"
          fill="#454242"
        />
        <path
          d="M12.3659 13.1192C11.7383 13.7467 10.8871 14.0993 9.99957 14.0993C9.11203 14.0993 8.26085 13.7467 7.63328 13.1192L5.86571 11.3516L4.48438 12.7329L6.90651 15.1551V17.8436C6.90651 18.1133 7.12517 18.3319 7.39489 18.3319H12.6043C12.874 18.3319 13.0926 18.1133 13.0926 17.8436V15.1551L15.5148 12.7329L14.1334 11.3516L12.3659 13.1192Z"
          fill="#454242"
        />
      </g>
      <defs>
        <clipPath id="clip0_7252_13114">
          <rect
            width="16.67"
            height="16.67"
            fill="white"
            transform="translate(1.66406 1.66406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ActivitiesIcon;
